const base = {
    host: 'https://pbl.zdw000.com',
    project: '/new_api_test/ycsj_pbl_program_test/api',
    scratch: '/test_new/scratch3_test',
    phone: '/test_new/phone_test'
}
export default base